import { Stack, useTheme } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { forwardRef } from "react";
import { useConfigQuery } from "services/staticDataService";

const FormattedDatePicker = forwardRef(
  (
    {
      value,
      onChangeDate,
      helperText,
      clearable = true,
      compact = false,
      type = "date",
      ...datePickerProps
    },
    ref
  ) => {
    const theme = useTheme();
    const hoverBg = theme.brand.gray.gainsboro;
    const { data: dateFormat } = useConfigQuery("date_format");
    const isMonthPicker = type === "month";
    const textFieldProps = compact
      ? {
          size: "small",
          helperText,
        }
      : {
          variant: "filled",
          InputLabelProps: { shrink: true },
          helperText,
        };

    return (
      <Stack direction={"column"}>
        <DatePicker
          views={isMonthPicker ? ["month", "year"] : undefined}
          {...datePickerProps}
          ref={ref}
          slotProps={{
            field: {
              clearable,
            },
            textField: {
              ...textFieldProps,
              ...(datePickerProps?.slotProps?.textField ?? {}),
            },
            actionBar: {
              actions: ["clear"],
              sx: {
                backgroundColor: "transparent",
                paddingTop: 0,
                "& button": {
                  color: "black",
                  backgroundColor: "#f0f0f0",
                  "&:hover": {
                    backgroundColor: hoverBg,
                  },
                },
              },
            },
            layout: {
              sx: {
                ".MuiPickersMonth-monthButton.Mui-selected": {
                  color: "#ffffff !important",
                },
                ".MuiPickersYear-yearButton.Mui-selected": {
                  color: "#ffffff !important",
                },
              },
            },
          }}
          format={
            isMonthPicker ? "MMM YY" : dateFormat?.date_format ?? "YYYY-MM-DD"
          }
          value={(value || "") === "" ? null : dayjs(value)}
          sx={{
            maxWidth: compact ? (clearable ? "12rem" : "10.5rem") : null,
          }}
          onChange={(e) => {
            if (e == null) {
              onChangeDate(null);
            } else if (dayjs(e).isValid()) {
              onChangeDate(dayjs(e).format("YYYY-MM-DD"));
            }
          }}
        />
      </Stack>
    );
  }
);

FormattedDatePicker.displayName = "FormattedDatePicker";

export default FormattedDatePicker;
